/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export { default as SliderDefaultDemo } from './slider-default.story';
export { default as SliderSingleDemo } from './slider-single.story';
export { default as SliderRangeDemo } from './slider-range.story';
export { default as SliderSingleControlledDemo } from './slider-single-controlled.story';
export { default as SliderDisabledDemo } from './slider-disabled.story';
export { default as SliderShowStepsDemo } from './slider-show-steps.story';
export { default as SliderShowValuesDemo } from './slider-show-values.story';
export { default as SliderCustomStepLengthDemo } from './slider-custom-step-length.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import SliderCustomStepLengthSourceRaw from './slider-custom-step-length.story.tsx?raw';
import SliderDefaultSourceRaw from './slider-default.story.tsx?raw';
import SliderDisabledSourceRaw from './slider-disabled.story.tsx?raw';
import SliderRangeSourceRaw from './slider-range.story.tsx?raw';
import SliderShowStepsSourceRaw from './slider-show-steps.story.tsx?raw';
import SliderShowValuesSourceRaw from './slider-show-values.story.tsx?raw';
import SliderSingleSourceRaw from './slider-single.story.tsx?raw';
import SliderSingleControlledSourceRaw from './slider-single-controlled.story.tsx?raw';

export const SliderDefaultSource = removeLicenseHeader(SliderDefaultSourceRaw);
export const SliderSingleSource = removeLicenseHeader(SliderSingleSourceRaw);
export const SliderRangeSource = removeLicenseHeader(SliderRangeSourceRaw);
export const SliderSingleControlledSource = removeLicenseHeader(
  SliderSingleControlledSourceRaw,
);
export const SliderDisabledSource = removeLicenseHeader(
  SliderDisabledSourceRaw,
);
export const SliderShowStepsSource = removeLicenseHeader(
  SliderShowStepsSourceRaw,
);
export const SliderShowValuesSource = removeLicenseHeader(
  SliderShowValuesSourceRaw,
);
export const SliderCustomStepLengthSource = removeLicenseHeader(
  SliderCustomStepLengthSourceRaw,
);
